import React from "react";
import {
  TIME_SCALE_OPTIONS,
  useSimulationStore,
} from "../../store/simulationStore";

export function TimeScaleControl() {
  const timeScale = useSimulationStore((s) => s.timeScale);
  const setTimeScale = useSimulationStore((s) => s.setTimeScale);

  return (
    <div className="tls-astro-control-block">
      <label htmlFor="tls-astro-timescale">Velocidade do tempo</label>
      <select
        id="tls-astro-timescale"
        value={timeScale}
        onChange={(e) => setTimeScale(Number(e.target.value))}
      >
        {TIME_SCALE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
